import type { LeadsSearchAllFiltersTypes } from "../types/leadsSearchFilters.dto";

/**
 * Route-supplied initial filter values (a URL deep link) for a surface: the **flat** panel value, keyed by
 * filter key, the same shape `useFiltersUpdate` folds into the DTO. Deliberately not narrowed to the leads
 * category — a deep link may seed any registered filter, including contacts, apps, signals and CRM.
 */
export type InitialLeadsSeed = Partial<LeadsSearchAllFiltersTypes>;

export const EMPTY_INITIAL_SEED: InitialLeadsSeed = {};

/** Whether the route carries any deep-link seed. The single predicate every seed consumer shares. */
export const hasInitialSeed = (seed: InitialLeadsSeed): boolean => Object.keys(seed).length > 0;
